<template>
  <div class="height-100">
    <base-container>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </base-container>
  </div>
</template>

<script>
export default {
  name: 'DataView',
  methods: {},
}
</script>

<style lang="scss" scoped></style>
